import { render, staticRenderFns } from "./ScrollTotop.vue?vue&type=template&id=608543d3"
import script from "./ScrollTotop.vue?vue&type=script&lang=js"
export * from "./ScrollTotop.vue?vue&type=script&lang=js"
import style0 from "./ScrollTotop.vue?vue&type=style&index=0&id=608543d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports